import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import * as styles from 'src/tables/ListingTable/ListingTable.css';
import {
  AutopriceCountRollupMetrics,
  BroadcastStatusRollupMetrics,
  FloorPriceRollupMetrics,
  PriceConflictRollupMetrics,
  RankPremiumRollupMetrics,
  SectionsRollupMetrics,
  SellThroughRateRollupMetrics,
  WebsitePriceRollupMetrics,
} from 'src/tables/ListingTable/RollupMetrics/RollupMetrics';
import { Event, ListingGroup } from 'src/WebApiController';

import { ListingGroupActions } from './ListingGroupActions';

type ListingTableGroupAffordanceHeaderProps = {
  groupName: string;
  metrics: {
    sections: string[];
    isAutoPricedCount: number;
    priceConflictCount: number;
    priceFloor: number | null;
    priceFloorCurrency: string | null;
    websitePriceFloor: number | null;
    absoluteRankPremium: number | null;
    relativeRankPremium: number | null;
    sellThroughRate: number | null;
    activeCount: number;
    soldCount: number;
  };
  totalListingCount: number;
  event: Event;
  listingGroup: ListingGroup;
};

export const ListingTableGroupAffordanceHeader = ({
  groupName,
  metrics,
  totalListingCount,
  event,
  listingGroup,
}: ListingTableGroupAffordanceHeaderProps) => {
  return (
    <Stack
      justifyContent="spaceBetween"
      className={styles.groupedRowHeader}
      style={{ minWidth: 0, overflow: 'hidden' }}
    >
      <Stack
        alignItems="center"
        gap="s"
        style={{
          flexShrink: 1,
          minWidth: 0,
          overflow: 'hidden',
        }}
      >
        <span
          style={{
            fontSize: vars.typography.fontSize.sm,
            whiteSpace: 'nowrap',
          }}
        >
          {groupName}:
        </span>
        {metrics.sections.length > 0 && (
          <SectionsRollupMetrics sections={metrics.sections} />
        )}
      </Stack>
      <Stack gap="s" style={{ overflow: 'auto' }} alignItems="center">
        <Stack gap="s" style={{ overflow: 'auto' }} alignItems="center">
          {metrics.isAutoPricedCount > 0 && (
            <AutopriceCountRollupMetrics
              isAutoPricedCount={metrics.isAutoPricedCount}
            />
          )}
          {metrics.priceConflictCount > 0 && (
            <PriceConflictRollupMetrics
              priceConflictCount={metrics.priceConflictCount}
            />
          )}
          {metrics?.priceFloor !== null && metrics.priceFloor > 0 && (
            <FloorPriceRollupMetrics
              floorPrice={metrics.priceFloor}
              currencyCode={metrics.priceFloorCurrency}
            />
          )}
          {metrics?.priceFloor !== null && metrics.priceFloor > 0 && (
            <WebsitePriceRollupMetrics
              websitePrice={metrics.websitePriceFloor}
              currencyCode={metrics.priceFloorCurrency}
            />
          )}
          {((metrics?.absoluteRankPremium !== null &&
            metrics.absoluteRankPremium > 0) ||
            (metrics?.relativeRankPremium !== null &&
              metrics.relativeRankPremium > 0)) && (
            <RankPremiumRollupMetrics
              absoluteRankPremium={metrics.absoluteRankPremium}
              relativeRankPremium={metrics.relativeRankPremium}
            />
          )}

          {metrics.sellThroughRate !== null && metrics.sellThroughRate > 0 && (
            <SellThroughRateRollupMetrics
              sellThroughRate={metrics.sellThroughRate}
            />
          )}
          <BroadcastStatusRollupMetrics
            activeBroadcastCount={metrics.activeCount}
            soldCount={metrics.soldCount}
            totalListingCount={totalListingCount}
          />
        </Stack>
        <ListingGroupActions
          event={event}
          listingGroup={listingGroup}
          isV2Variant={true}
        />
      </Stack>
    </Stack>
  );
};
